import { headerLogoStartBase64 } from './HeaderLogoStore.js';

export const updateHeaderLogoStartBase64 = (value) => headerLogoStartBase64.update((oldValue) => value);
